import React, { useState } from 'react';
import { Modal, TextField, Button, Box } from '@mui/material';

interface AddModalProps {
    open: boolean;
    onClose: () => void;
    onSave: (name: string) => void;
}

const UIInputModal: React.FC<AddModalProps> = ({ open, onClose, onSave }) => {
    const [inputName, setInputName] = useState<string>("");

    const handleSave = () => {
        onSave(inputName);
        setInputName("");
        onClose()
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={{ ...modalStyle }}>
                <h2>Add New Input Field</h2>
                <TextField
                    label="Input Field Name"
                    value={inputName}
                    onChange={(e) => setInputName(e.target.value)}
                    fullWidth
                    margin="normal"
                />
                <div style={{display:"flex",justifyContent:"center",width:"100%"}}>
                <Button variant="contained" color="primary" onClick={handleSave} disabled={!inputName.trim()}>
                    Save
                </Button>
                </div>
            </Box>
        </Modal>
    );
};

const modalStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};


export default UIInputModal;
